import script from "./DentalService.vue?vue&type=script&setup=true&lang=js"
export * from "./DentalService.vue?vue&type=script&setup=true&lang=js"

import "./DentalService.vue?vue&type=style&index=0&id=953e285e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953e285e"]])

export default __exports__